module.exports = __webpack_public_path__ + "img/hamburger.589ee8cc.svg";